import { Localized } from "@fluent/react"
import { Chip, Typography } from "@mui/material"
import ThumbDownIcon from '@mui/icons-material/ThumbDown'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'

export const YesNoChip = (props: { value: boolean }) => {
    const { value } = props

    const label = value
        ? <Localized id='yes'>Tak</Localized>
        : <Localized id='no'>Nie</Localized>

    return <Chip
        icon={value ? <ThumbUpIcon fontSize="small" color="success" /> : <ThumbDownIcon fontSize="small" color="error" />}
        label={<Typography variant="button">{label}</Typography>}
    />
}
